export const capitalizeWords = (string: string): string=> {
  if (string === undefined || string === null){
    return ''
  }

  return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
}
